const HALL_ALIASES: Record<string, string> = {
  A: "A",
  C: "C",
  AC: "C",
  AIRCRAFT: "C",
  "AIRCRAFT CONNECTION": "C",
  "AIRCRAFT DISPLAY": "C",
};

export function normalizeHallId(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  const normalized = raw.replace(/^hall\s+/i, "").trim().toUpperCase();
  return HALL_ALIASES[normalized];
}

/** Aircraft Connection / outdoor display booths (AC_03, GV_01) live on the Hall C map. */
export function hallIdFromBooth(booth: string | null | undefined): string | undefined {
  const id = (booth ?? "").trim().toUpperCase();
  if (/^AC[_-]?\d/.test(id) || /^GV[_-]/.test(id)) return "C";
  return undefined;
}

export function resolveMapHall(hall?: string | null, booth?: string | null): string | undefined {
  return hallIdFromBooth(booth) ?? normalizeHallId(hall);
}
